import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";
import { Role } from "@builder/types/Role.type";
import { buildUrlQuery } from "@builder/utils/buildUrlQuery";

export const rolesApi = createApi({
    reducerPath: "rolesApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}role`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["roles"],
    endpoints: builder => ({
        getRoles: builder.query<
            Role[],
            { companyId: string; search?: string; skip?: number; limit?: number; companySettings?: any; organizationId?: string }
        >({
            query: ({ companyId, ...query }) => `/builder/query/${companyId}?${buildUrlQuery(query)}`,
            providesTags: ["roles"]
        }),
        getRolesByIds: builder.query<Role[], { companyId: string; ids: string[]; organizationId?: string }>({
            query: ({ companyId, ids, organizationId }) => {
                const params = new URLSearchParams({ ids: ids.join(",") });
                if (organizationId) params.append("organizationId", organizationId);
                return `/builder/by-ids/${companyId}?${params.toString()}`;
            },
            providesTags: ["roles"]
        })
    })
});

export const { useGetRolesQuery, useGetRolesByIdsQuery } = rolesApi;
